import { Component, Input, Output, EventEmitter, OnChanges, SimpleChanges, ViewChild } from '@angular/core';
import { FlagGroup, FlagStatus } from '../../../../shared/interfaces';
import { ExtensionGrantedDeadlinesComponent } from '../../../extension-granted-deadlines/extension-granted-deadlines.component';
import { FlagManagerService } from '../../flag-manager.service';
import { GroupNameModalComponent } from '../group-name-modal/group-name-modal.component';

@Component({
  selector: 'app-flag-management-bar',
  templateUrl: './flag-management-bar.component.html',
  styleUrls: ['./flag-management-bar.component.scss'],
})
export class FlagManagementBarComponent implements OnChanges {
  @Input() selectedFlagIds: number[] = [];
  @Input() selectedGroup: any = null;
  @Input() underwritingStatus: string = '1';
  @Input() allFlags: any[] = [];
  @Input() managingGroups: boolean = false;
  @Input() groups: any[] = [];
  @Input() inspection: any;
  @Input() resolveBarSelectedTab: any;
  @Input() selectedTab: string;

  @Input() shouldShowResolveOptions: boolean = false;
  @Output() selectAll = new EventEmitter<void>();
  @Output() groupFlags = new EventEmitter<void>();
  @Output() ungroupFlags = new EventEmitter<void>();
  @Output() applyTemplate = new EventEmitter<void>();
  @Output() extensionGrantedDeadlines = new EventEmitter<void>();
  @Output() ignoreFlags = new EventEmitter<void>();
  @Output() keepFlags = new EventEmitter<void>();
  @Output() changeFlagStatusBulk = new EventEmitter<FlagStatus>();
  @Output() uncheckAllFlags = new EventEmitter<void>();
  @Output() showGroupTemplate = new EventEmitter<void>();
  @Output() createGroup = new EventEmitter<any>();
  @Output() mergeInGroup = new EventEmitter<FlagGroup>();

  @ViewChild('extensionModal') extensionModal: ExtensionGrantedDeadlinesComponent; // Fixed ViewChild type
  @ViewChild('groupNameModal', { static: true }) private groupNameModal: GroupNameModalComponent;

  constructor(private flagManagerService: FlagManagerService) {}

  showModal = false;
  changeStatus = false;
  loading = false;
  FlagStatus = FlagStatus;
  selectedFlags: any[] = [];

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['selectedFlagIds'] || changes['allFlags']) {
      this.updateSelectedFlags();
    }
  }

  private updateSelectedFlags(): void {
    if (this.allFlags && this.selectedFlagIds) {
      this.selectedFlags = this.allFlags.filter(flag => this.selectedFlagIds.includes(flag.id));
    } else {
      this.selectedFlags = [];
    }
  }

  get hasSelectedFlags(): boolean {
    return this.selectedFlagIds && this.selectedFlagIds.length > 0;
  }

  get selectedCount(): number {
    return this.selectedFlagIds ? this.selectedFlagIds.length : 0;
  }

  canGroupFlags() {
    if (this.selectedFlags.length === 0) {
      return false;
    }

    if (!this.selectedFlags[0]?.subtype && !this.selectedFlags[0]?.subtype?.typeId) {
      return false;
    }

    const type = this.selectedFlags[0]?.subtype?.typeId;

    // Incompatible flags
    if (this.selectedFlags.find(f => f.subtype.typeId !== type)) {
      return false;
    }

    return true;
  }

  allSelectedAreExcluded() {
    return !this.selectedFlags.find(f => !f.ignore);
  }

  hasNonDiscrepancyFlag() {
    for (const flag of this.selectedFlags) {
      if (flag.subtypeId === 2 || flag.status === 3) {
        return true;
      }
    }
  }

  onGroupFlags() {
    const type = this.selectedFlags[0].subtype.typeId;
    const groups = this.groups.filter(g => !g.subtype || g.subtype.typeId === type);
    this.groupNameModal.show(groups, this.groups, false);
  }

  onUngroupFlags() {
    this.ungroupFlags.emit();
  }

  onSelectAll() {
    const allFlagIds = this.allFlags.map(flag => flag.id);
    this.flagManagerService.selectAllFlags(allFlagIds);
  }

  unSelectAll() {
    this.flagManagerService.deselectAllFlags();
  }

  onApplyTemplate() {
    this.applyTemplate.emit();
  }

  onExtensionGrantedDeadlines() {
    this.extensionModal.show({
      inspection: this.inspection,
      confirmed: () => {
        // Handle confirmation callback
        this.flagManagerService.deselectAllFlags();
        console.log('Extension deadlines confirmed');
      },
    });
  }

  onIgnoreFlags() {
    this.ignoreFlags.emit();
  }

  onKeepFlags() {
    this.keepFlags.emit();
  }

  onChangeFlagStatusBulk(status: FlagStatus) {
    console.log('onChangeFlagStatusBulk', status);
    this.changeFlagStatusBulk.emit(status);
  }

  onGroupNameProceed(groupName: string) {
    this.showModal = false;
    this.selectedFlags = this.allFlags.filter(flag => this.selectedFlagIds.includes(flag.id));
    const group = {
      description: this.selectedFlags[0].description,
      subtype: this.selectedFlags[0].subtype,
      name: groupName,
      violation: this.selectedFlags[0].violation,
      discrepancy: this.selectedFlags[0].discrepancy,
      helpPictures: this.selectedFlags[0].helpPictures,
      subtypeId: this.selectedFlags[0].subtypeId,
      skipConfirmation: true,
    };

    this.createGroup.emit({ ...group, groupName: groupName });
  }

  onMergeInGroupProceed(group: FlagGroup) {
    this.mergeInGroup.emit(group);
  }

  onShowGroupTemplate() {
    this.showGroupTemplate.emit();
  }

  closeModal() {
    this.showModal = false;
  }
}
